import request from '@/utils/request'

/**
 * @description 批量发货
 * @param data
 * @returns {*}
 */
export function multipleShip(data) {
  return request.post('/phalapi/public/?service=App.Trade.doMultiShip', data)
}

/**
 * @description 读取excel文件
 * @param data
 * @returns {*}
 */
export function implodeExcel(data) {
  return request.post('/phalapi/public/?service=App.Trade.importEms', data)
}

/**
 * @description 获取全部考试树
 * @param {*} data
 */
export function getAllCategoryTree(data) {
  return request.post('/phalapi/public/?service=App.Common.getAllCategoryTree', data)
}

/**
 * @description 获取快递信息
 * @param params
 * @returns {*}
 */
export function getEmsInfo(params) {
  const sdk_domain = request.defaults.__webConfig.SDK_DOMAIN
  const baseURL = process.env.NODE_ENV === 'development' ? '/sdk' : '//' + sdk_domain
  if (params.ems === '邮政国内小包') {
    params.ems = '邮政快递包裹'
  }
  return request.get('/kdapi.php', { params, baseURL })
}

/**
 * @description 获取快递预测信息列表
 * @param {*} data { delivery_num: 快递编号 }
 * @returns
 */
export function getEmsPredictList(data) {
  return request.post('/phalapi/public/?service=App.Common.GetPredictDelivery', data)
}

/**
 * @description 获取快捷日期选择列表
 * @returns {*}
 */
export function getSearchQuickDays(data) {
  return request.post('/phalapi/public/?service=App.Statistics.GetSearchQuickDays', data)
}

/**
 * @description 编辑器复制内容图片抓取重传
 * @param {*} data
 * @returns
 */
export function catchImage(data) {
  return request.post('/static/ueditor/php/controller.php?action=catchimage', data)
}

/**
 * @description 获取屏蔽词列表
 * @param {*} data
 * @returns
 */
export function getScreenWordList(data) {
  return request.post('/phalapi/public/?service=App.BannerWords.getWordsListByType', data)
}

/**
 * @description 添加屏蔽词
 * @param {*} data
 * @returns
 */
export function addScreenWord(data) {
  return request.post('/phalapi/public/?service=App.BannerWords.addWordsByType', data)
}

/**
 * @description 删除屏蔽词
 * @param {*} data
 * @returns
 */
export function deleteScreenWord(data) {
  return request.post('/phalapi/public/?service=App.BannerWords.delWordByType', data)
}

/**
 * @description 推送预览
 * @param {*} data
 * @returns
 */
export function previewMessage(data) {
  return request.post('/phalapi/public/?service=App.Common.MsgPreView', data)
}

/**
 * @description 获取推送海报二维码
 * @param {*} data
 * @returns
 */
export function getMsgQRCode(data) {
  return request.post('/phalapi/public/?service=App.MassMessage.getMsgQRCode', data)
}

/**
 * @description 保存Json格式全局配置
 * @param {*} data
 * @returns
 */
export function saveJsonSetting(data) {
  return request.post('/phalapi/public/?service=App.Setting.saveJsonSetting', data)
}

/**
 * @description 获取城市树形
 * @param {*} data
 * @returns
 */
export function getCityTree(data) {
  const baseURL = process.env.NODE_ENV === 'development' ? '/ehafo_cdn' : '//cdn.ehafo.com'
  const jsonSuffix = location.origin.indexOf('.dev') > -1 ? '_dev' : ''
  return request.get('/city_data/city' + jsonSuffix + '.json?v=' + (data.version || ''), { baseURL, withCredentials: false })
}

/**
 * @description 获取城市数据版本
 * @param {*} data
 * @returns
 */
export function getCityVersion(data) {
  return request.post('/phalapi/public/?service=App.Common.getCityVersion', data)
}

/**
 * @description 根据名称获取全局配置
 * @param {*} data
 * @returns
 */
export function getInfoByName(data) {
  return request.post('/phalapi/public/?service=App.Setting.getInfoByName', data)
}

/**
 * @description 保存系统设置
 * @param {*} data
 * @returns
 */
export function saveSystemSeting(data) {
  return request.post('/phalapi/public/?service=App.Setting.saveSystemSeting', data)
}

/**
 * @description 获取excel内容
 * @param {*} data
 * @returns
 */
export function getExcelContent(data) {
  data.upload = true
  return request.post('/phalapi/public/?service=App.Common.getExcelContent', data)
}

/**
 * @description 获取成绩分享活动配置(临时)
 * @param {*} data
 * @returns
 */
export function getScoreActSetting(data) {
  return request.post('/phalapi/public/?service=App.Setting.GetScoreActSetting', data)
}

/**
 * @description 修改成绩分享活动开关(临时)
 * @param {*} data
 * @returns
 */
export function saveScoreActSetting(data) {
  return request.post('/phalapi/public/?service=App.Setting.SaveScoreActSetting', data)
}

/**
 * @description 强制修改不通过设置(临时)
 * @param {*} data
 * @returns
 */
export function refuseScoreActContent(data) {
  return request.post('/phalapi/public/?service=App.Setting.refuseScoreActContent', data)
}
/**
 * @description 通过未通过列表某项(临时)
 * @param {*} data
 * @returns
 */
export function passScoreActContent(data) {
  return request.post('/phalapi/public/?service=App.Setting.PassScoreActContent', data)
}
/**
 * @description 获取未通过列表(临时)
 * @param {*} data
 * @returns
 */
export function getRefuseScoreActContentList(data) {
  return request.post('/phalapi/public/?service=App.Setting.GetRefuseScoreActContentList', data)
}
/**
 * @description 记录前端获取到的异常数据
 * @param {*} data
 * @returns
 */
export function saveLogByApi(data) {
  return request.post('/phalapi/public/?service=App.Common.SaveLogByApi', data)
}

/**
 * @description 获取退款订单列表
 * @param {*} data
 */
export function commonRefundOrders(data) {
  return request.post('/phalapi/public/?service=App.Trade.commonRefundOrders', data)
}

/**
 * @description 图片OCR识别，包含位置
 * @param {*} data
 * @returns
 */
export function imageOcrLocation(data) {
  return request.post('/phalapi/public/?service=App.Common.imgUrlToStringBaidu', data)
}

/**
 * @description 获取商品列表
 * @param {*} data
 * @returns
 */
export function getShopList(data) {
  return request.post('/phalapi/public/?service=App.Shop.lists', data)
}

/**
 * @description 获取书籍信息
 * @param {*} data
 * @returns
 */
export function getTextBookStatus(data) {
  return request.post('/phalapi/public/?service=Book.TextBook.GetTextBookStatus', data)
}
// 获取考试的关联书籍
export function getBookListByCid(data) {
  return request.post('/phalapi/public/?service=Check.Tiku.GetBookListByCid', data)
}
// 通用接口获取订单信息
export function getTradeInfoApi(data) {
  return request.post('/phalapi/public/?service=App.Common.GetTradeInfo', data)
}
/**
 * @description 获取全部小程序列表
 * @param {*} data
 */
export function getWxXcxListsApi(data) {
  return request.post('/phalapi/public/?service=App.Common.GetWxXcxLists', data)
}

/**
 * @description 获得排除仅VIP开放已经建筑类型的考试cid列表
 */
export function getOpenExamCidsExcludeOnlyVipAndBuild() {
  return request.post('/phalapi/public/?service=App.Common.getOpenExamCidsExcludeOnlyVipAndBuild')
}

/**
 * @description 上传文件
 * @param {*} data FormData对象
 * @returns {Promise}
 */
export function uploadFile(data) {
  return request.post('/phalapi/public/?service=App.Common.SaveFile', data)
}
